<div class="card">
  <div class="card-body">
    <h3 class="header-title mb-3">Nations Cup</h3>
    
    <div *ngIf="teamResults.length === 0" class="text-center">
      <p>Loading team results...</p>
    </div>

    <div *ngFor="let team of teamResults" class="team-container mb-4">
      <!-- Team Header -->
      <div class="team-header-row d-flex align-items-center">
        <div class="team-name flex-grow-1">
          <img *ngIf="team.logo" [src]="team.logo" alt="Team Logo" class="team-logo mr-2">
          <strong>{{ (team.name || team.teamName || 'Team ' + team.id) | uppercase }}</strong>
        </div>
        <div class="team-header-item">ROUND 1</div>
        <div class="team-header-item" *ngIf="team.result_2">ROUND 2</div>
        <div class="team-header-item" *ngIf="team.result_3">JO</div>
      </div>

      <!-- Rider Rows -->
      <div *ngFor="let entry of team.entries" class="rider-row d-flex align-items-center">
        <div class="rider-info flex-grow-1">
          <div>{{entry.riderName || entry.jinete}}</div>
          <div>{{entry.horseName || entry.caballo}}</div>
        </div>
        <div class="result-item" [class.strike]="isStruck(entry.result1)">
          {{formatResult(entry.result1)}}
        </div>
        <div class="result-item" *ngIf="team.result_2" [class.strike]="isStruck(entry.result2)">
          {{formatResult(entry.result2)}}
        </div>
        <div class="result-item" *ngIf="team.result_3">
          {{entry.result3}}
        </div>
      </div>

      <!-- Team Footer -->
      <div class="team-footer-row d-flex align-items-center">
        <div class="footer-label flex-grow-1">
          <span class="mr-3"><strong>TOTAL</strong></span>
          <span *ngIf="team.totalFaults" class="mr-3">{{team.totalFaults}} PENALTIES</span>
          <span>RANK {{team.rank || 'N/A'}}</span>
        </div>
        <div class="result-item"><strong>{{team.result_1}}</strong></div>
        <div class="result-item" *ngIf="team.result_2"><strong>{{team.result_2}}</strong></div>
        <div class="result-item" *ngIf="team.result_3"><strong>{{team.result_3}}</strong></div>
      </div>
    </div>
  </div>
</div> 